import React from "react";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import {
	BsBarChartFill,
	BsBuilding
} from "react-icons/bs";
import { growthGoalsColumns } from "./growth-columns-config";
import { hasValue } from "../../../utils/pacto-rebates-utils";
import TooltipGeneric from "../../../../shared/components/generic/tooltip/tooltip-generic";

export const summaryConfig = ({
	simulation
} = {}) => {
	const calculatedInstallments = simulation?.calculatedInstallments || [];
	const variluxGoals = simulation?.variluxGoals || [];
	const growthGoals = simulation?.growthGoals || [];
	const grossSalesIndexUsed = simulation?.grossSalesIndex ?? "";
	let averageMonthlySales = simulation?.averageMonthlySales;
	
	if (simulation?.basedOnMinimumValues && simulation?.clientNotfound) {
		averageMonthlySales = simulation?.minimumAverageMonthlySales; 
	}

	const commercialGroupName =
		simulation?.commercialGroupName ||
		simulation?.nomeGrupoComercial ||
		simulation?.raw?.perfilCliente?.nomeGrupoComercial ||
		"";

	const hasAverageMonthlySalesVarilux =
		Number(simulation?.averageMonthlySalesVarilux) > 0;

	const clientProfileItems = [
		{
			label: "Média de Faturamento em Net Sales por mês",
			value: MonetaryUtils.formatCurrency(averageMonthlySales),
			rawValue: averageMonthlySales
		},
		{
			label: (
				<span className="simulation-summary__label-with-tooltip">
					Média de Faturamento em Gross Sales por mês

					<TooltipGeneric
						content={
							grossSalesIndexUsed
								? `Valor obtido pelo cálculo +${grossSalesIndexUsed}% * NET SALES`
								: "Valor obtido pelo cálculo índice Gross Sales * NET SALES"
						}
						iconSize={14}
						placement="top"
					/>
				</span>
			),
			value: MonetaryUtils.formatCurrency(simulation?.averageGrossSales),
			rawValue: simulation?.averageGrossSales
		},
		...(hasAverageMonthlySalesVarilux
			? [
				{
					label: "Média de varilux / mês",
					value: simulation?.averageMonthlySalesVarilux,
					rawValue: simulation?.averageMonthlySalesVarilux
				}
			]
			: []),
		...(commercialGroupName
			? [
				{
					label: (
						<>
							Média de faturamento Net Sales / mês das lojas do grupo{" "}
							<span className="simulation-summary__label-highlight">
								{commercialGroupName}
							</span>
							{" "}fora do programa rebate
						</>
					),
					value: MonetaryUtils.formatCurrency(simulation?.averageMonthlySalesGroup),
					rawValue: simulation?.averageMonthlySalesGroup
				}
			]
			: [])
	];

	const hasClientProfile = clientProfileItems.some(item => {
		return hasValue(item.rawValue);
	});

	return [
		...(hasClientProfile
			? [
				{
					key: "clientProfile",
					title: "Perfil do Cliente",
					icon: BsBarChartFill,
					variant: "inline",
					items: clientProfileItems.map(({ rawValue, ...item }) => item)
				}
			]
			: []),
		{
			key: "equipmentConditions",
			title: "Equipamento e Condições",
			icon: BsBuilding,
			variant: "card-center",
			items: [
				{
					label: "Equipamento",
					value: simulation?.equipmentName || "-"
				},
				{
					label: "Valor",
					value: MonetaryUtils.formatCurrency(simulation?.equipmentValue)
				},
				{
					label: "Parcelas",
					value: simulation?.installments || "-"
				}
			]
		},
		{
			key: "paymentValues",
			variant: "card",
			items: [
				{
					label: "% de Entrada",
					value: hasValue(simulation?.downPaymentPercentage)
						? `${simulation.downPaymentPercentage}%`
						: "-"
				},
				{
					label: "Entrada",
					value: hasValue(simulation?.initialPayment)
						? MonetaryUtils.formatCurrency(simulation?.initialPayment)
						: "-"
				},
				...calculatedInstallments.map((installment, index) => {
					const installmentValue =
						installment.calculatedValue ??
						installment.value ??
						installment.valorCalculado;

					return {
						label: `Parcela ${installment.installment || installment.parcela || index + 1}`,
						value: hasValue(installmentValue)
							? MonetaryUtils.formatCurrency(installmentValue)
							: MonetaryUtils.formatCurrency(0)
					};
				})
			]
		},
		{
			key: "variluxGoals",
			title: "Metas de pares Varilux",
			variant: "varilux",
			items: variluxGoals.map((goal, index) => ({
				label: goal.label || `Ano ${goal.year || goal.ano || index + 1}`,
				value: `${goal.value || goal.meta || 0}`
			}))
		},
		{
			key: "growthGoals",
			title: "Metas de crescimento em vendas",
			type: "table",
			columns: growthGoalsColumns({
				grossSalesIndexUsed
			}),
			data: growthGoals,
			rowKey: "growth"
		}
	];
};